import styled from 'styled-components';

export const Form = styled.form`
  margin: 0;
  padding: 0;
`;

export const RadioSearchContainer = styled.div`
  color: #6e6e6e;
  align-items: center;

  & input {
    margin-right: 2px;
  }
`;

export const LoginSeparator = styled.div`
  grid-column: span 2;
  width: 100%;
  display: flex;
  border-top: 2px solid #eae7e7;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
`;
